import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type FacingMode = 'user' | 'environment';

type State = {
  max: number;
  photos: (string | null)[]; // dataURL por slot
  facingMode: FacingMode; // compartido entre slots (puede ser por-slot si lo prefieres)
};

const initialState: State = {
  max: 3,
  photos: Array(3).fill(null),
  facingMode: 'environment',
};

const equipmentPhotosSlice = createSlice({
  name: 'equipmentPhotos',
  initialState,
  reducers: {
    setMax(state, action: PayloadAction<number>) {
      const m = Math.max(1, action.payload);
      state.max = m;
      if (state.photos.length !== m) {
        const next = Array(m).fill(null) as (string | null)[];
        for (let i = 0; i < Math.min(state.photos.length, m); i++) next[i] = state.photos[i];
        state.photos = next;
      }
    },
    confirmPhoto(state, action: PayloadAction<{ index: number; dataUrl: string }>) {
      const { index, dataUrl } = action.payload;
      if (index >= 0 && index < state.max) state.photos[index] = dataUrl;
    },
    removePhoto(state, action: PayloadAction<number>) {
      const i = action.payload;
      if (i >= 0 && i < state.max) state.photos[i] = null;
    },
    toggleFacingMode(state) {
      state.facingMode = state.facingMode === 'user' ? 'environment' : 'user';
    },
    resetEquipmentPhotosState() {
      return initialState;
    },
  },
});

export const { setMax, confirmPhoto, removePhoto, toggleFacingMode, resetEquipmentPhotosState } =
  equipmentPhotosSlice.actions;
export default equipmentPhotosSlice.reducer;
